// extracted by mini-css-extract-plugin
export var headerGap = "styles-module--header-gap--bCyiP";